import React, { memo } from "react";
import { Modal } from "react-bootstrap";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type Props = {
  showPermissionError: boolean;
  onPressPermissionsError: () => void;
  msg: any;
};

const ErrorModal = (props: Props) => {
  return (
    <Modal show={props.showPermissionError} centered className="errorModal">
      <Modal.Body>
        <div className="error_modal_content">
          <div className="check-icon">
            <FontAwesomeIcon
              icon={faCircleXmark as IconProp}
              className="uncheck_circle"
            />
          </div>
          <div className="error_text_content">{props.msg}</div>
          <div className="error_end_btn">
            <button
              onClick={props.onPressPermissionsError}
              className="v_button"
            >
              Close
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default memo(ErrorModal);
